import {
    ActiveButton,
    BackButton,
    BorderDiv,
    TextGrid,
    TopText,
} from '../users/style';

import back_arrow from '../../common/images/back_arrow.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { Status } from '../trade/style';
import { Loader } from '../../common/component';
import { useGetSingleTopicQuery } from '../../store/topicApi';
import { TopicDetails } from './topicDetails';

export const ViewTopic = () => {
    const param = useParams();
    const topicId = param?.id as string;

    const navigate = useNavigate();
    const { data: topicData, isLoading } = useGetSingleTopicQuery(topicId);

    return (
        <div className="pb-4">
            <div className="d-flex align-items-center my-2">
                <BackButton onClick={() => navigate(-1)}>
                    <img src={back_arrow} alt="" /> Back
                </BackButton>
                <TopText>
                    {' '}
                    <span>/Topic</span> / View Topic
                </TopText>
            </div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <BorderDiv className=" my-4 ">
                        <Col sm={8}>
                            <TextGrid>
                                <ActiveButton>Topic details</ActiveButton>
                            </TextGrid>
                        </Col>
                        <Col className="d-flex align-items-center justify-content-end mb-2 mb-sm-0">
                            <Status>
                                {topicData?.data?.status ? (
                                    <p style={{ color: '#34a853' }}>Active</p>
                                ) : (
                                    'Inactive'
                                )}
                            </Status>
                        </Col>
                    </BorderDiv>
                    {<TopicDetails />}
                </>
            )}
        </div>
    );
};
